<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="max-w-md w-full mx-auto text-center px-4">
      <div class="mb-8">
        <!-- 503 Icon -->
        <div class="mx-auto w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mb-6">
          <svg class="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-6xl font-bold text-text-primary mb-4">503</h1>

        <!-- Error Title -->
        <h2 class="text-2xl font-semibold text-text-primary mb-4">Service Unavailable</h2>

        <!-- Error Description -->
        <p class="text-text-secondary mb-8">
          We're currently performing scheduled maintenance. The service will be back online shortly.
        </p>
      </div>

      <!-- Maintenance Info -->
      <div class="mb-8 p-4 bg-orange-50 border border-orange-200 rounded-lg">
        <div class="text-sm text-orange-700">
          <p class="font-medium mb-2">Maintenance Window</p>
          <p>{{ maintenanceMessage }}</p>
        </div>
      </div>

      <!-- Auto Refresh Counter -->
      <div v-if="autoRefresh" class="mb-8 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <div class="flex items-center justify-center text-sm text-blue-700">
          <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>Automatically checking in {{ countdown }} seconds</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <button
            @click="checkService"
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors"
            :disabled="isChecking"
        >
          <span v-if="isChecking">Checking...</span>
          <span v-else>Check Service Status</span>
        </button>

        <button
            @click="toggleAutoRefresh"
            class="w-full bg-background-light hover:bg-background-lighter text-text-primary font-medium py-3 px-6 rounded-md border border-background-lighter transition-colors"
        >
          {{ autoRefresh ? 'Disable' : 'Enable' }} Auto-Check
        </button>
      </div>

      <!-- Additional Info -->
      <div class="mt-8 pt-8 border-t border-background-lighter">
        <p class="text-sm text-text-secondary mb-4">Stay updated on our status:</p>
        <div class="flex justify-center space-x-6 text-sm">
          <a href="#" class="text-primary hover:underline">Status Page</a>
          <a href="#" class="text-primary hover:underline">Twitter Updates</a>
          <router-link to="/contact" class="text-primary hover:underline">Contact Us</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceUnavailable',
  data() {
    return {
      autoRefresh: true,
      countdown: 30,
      isChecking: false,
      countdownInterval: null,
      maintenanceMessage: 'Estimated completion: within the next 30 minutes'
    }
  },
  methods: {
    async checkService() {
      this.isChecking = true;

      try {
        // Simple check - try to fetch a lightweight endpoint
        const response = await fetch('/api/health', { method: 'HEAD' });
        if (response.ok) {
          // Service is back online
          this.$router.go(0); // Refresh current route
        }
      } catch (error) {
        console.log('Service still unavailable');
      } finally {
        this.isChecking = false;
      }
    },

    toggleAutoRefresh() {
      this.autoRefresh = !this.autoRefresh;
      if (this.autoRefresh) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },

    startCountdown() {
      this.countdown = 30;
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.checkService();
          this.countdown = 30; // Reset countdown
        }
      }, 1000);
    },

    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    }
  },

  mounted() {
    document.title = '503 - Service Unavailable | Eskrag';
    if (this.autoRefresh) {
      this.startCountdown();
    }
  },

  beforeUnmount() {
    this.stopCountdown();
  }
}
</script>
